import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {debounceTime} from 'rxjs/operators';
import {AttractionsService} from '../../../services/attractions.service';
import {UtilsService} from '../../../services/utils.service';
import {LocationsService} from '../../../services/locations.service';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-attraction-view',
  templateUrl: './attraction-view.component.html',
  styleUrls: ['./attraction-view.component.scss']
})
export class AttractionViewComponent {

  modelChanged: Subject<string> = new Subject<string>();

  attractionOptions = [];
  selectedAttractionId;
  attraction = {};
  locationsList = [];
  filePaths = [];

  selectedFiles: FileList;

  galleryItems: Array<any>;

  utilKit = UIkit.util;

  newCost = {
    name: '',
    amount: '',
    description: '',
    perPerson: true
  };

  availableAttractionTypes = [];
  availableActivityTypes = [];
  availableDifficulties = [];
  availableAccommodationTypes = [];
  availableAmenities = [];
  availableFlows = [];
  availableRaftingClasses = [];
  availableCuisines = [];
  availableSeasons = [];
  availableLocations = [];

  constructor(private graphqlService: AttractionsService,
              private locationsService: LocationsService,
              private utilsService: UtilsService,
              private router: Router,
              private route: ActivatedRoute) {

    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateAttraction());

    route.params.subscribe(params => {
      if (params['id']) {
        this.selectedAttractionId = params['id'];

        this.graphqlService.getAttractionMetaData().subscribe(result => {
          if (result && result.data) {
            this.availableAttractionTypes = JSON.parse(JSON.stringify(result.data['availableAttractionTypes']));
            this.availableActivityTypes = JSON.parse(JSON.stringify(result.data['availableActivityTypes']));
            this.availableDifficulties = JSON.parse(JSON.stringify(result.data['availableDifficulties']));
            this.availableAccommodationTypes = JSON.parse(JSON.stringify(result.data['availableAccommodationTypes']));
            this.availableAmenities = JSON.parse(JSON.stringify(result.data['availableAmenities']));
            this.availableFlows = JSON.parse(JSON.stringify(result.data['availableFlows']));
            this.availableRaftingClasses = JSON.parse(JSON.stringify(result.data['availableRaftingClasses']));
            this.availableCuisines = JSON.parse(JSON.stringify(result.data['availableCuisines']));
            this.availableSeasons = JSON.parse(JSON.stringify(result.data['availableSeasons']));
            this.availableLocations = JSON.parse(JSON.stringify(result.data['allLocations']));
          }
        });

        this.graphqlService.getAttraction(this.selectedAttractionId).subscribe(result => {
          if (result && result.data) {
            this.attraction = JSON.parse(JSON.stringify(result.data['attraction']));

            this.updateCheckedProp(this.availableAmenities, 'amenities');
            this.updateCheckedProp(this.availableSeasons, 'bestSeason');
            this.updateCheckedProp(this.availableCuisines, 'cuisines');
          }
        });
      }
    });
  }

  dataChanged() {
    this.modelChanged.next();
  }

  updateAttraction() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.attraction['name']);
    if (requiredSuccess) {
      this.graphqlService.update(this.attraction).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Attraction Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update Attraction.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  updateCheckedProp(arr, prop) {
    if (arr) {
      arr.forEach(obj => {
        if (this.attraction[prop].indexOf(obj.key) > -1) {
          obj.checked = true;
        }
      });
    }
  }

  updateStringArray(obj, prop) {
    if (!this.attraction[prop]) {
      this.attraction[prop] = [];
    }
    if (obj.checked) {
      this.attraction[prop].push(obj.key);
    } else {
      const index = this.attraction[prop].indexOf(obj.key);
      if (index !== -1) {
        this.attraction[prop].splice(index, 1);
      }
    }
    this.updateAttraction();
  }

  hasBestSeason() {
    // return this.attractionOptions['withBestSeason'].indexOf(this.attraction.type) > -1;
    return true;
  }


  addCost() {
    if (this.attraction['additionalCosts'] == null) {
      this.attraction['additionalCosts'] = [];
    }
    this.attraction['additionalCosts'].push(this.newCost);
    this.updateAttraction();
    this.resetNewCost();
  }

  removeCost(cost) {
    this.attraction['additionalCosts'].splice(this.attraction['additionalCosts'].indexOf(cost), 1);
    this.updateAttraction();
  }

  resetNewCost() {
    this.newCost = {
      name: '',
      amount: '',
      description: '',
      perPerson: true
    };
  }

  upload() {
    /*const file = this.selectedFiles.item(0);
    this.uploadService.uploadfile(file, function (err, data) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
        return false;
      }

      console.log('Successfully uploaded file.', data);
    });*/
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  isPhoto(mimetype) {
    return mimetype.indexOf('image') > -1;
  }


  addToGallery(file) {
    // this.attraction.gallery.push(file);
    this.updateAttraction();

  }

  setAsFeaturedImage(file) {
    this.attraction['featuredImage'] = file;
    this.updateAttraction();
  }

  deleteFile(id) {
    this.updateAttraction();
  }


  removeFromGallery(file) {
    this.galleryItems.splice(this.galleryItems.indexOf(file), 1);
    this.updateAttraction();
  }

  updateGalleryOrder(file) {
    this.updateAttraction();
  }

  deleteAttraction() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.attraction).subscribe(({data}) => {
      this.utilsService.openSnackBar('Attraction Deleted !!', '');
      this.router.navigate(['/attractions']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete attraction.', '');
      console.log('there was an error sending the query', error);
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/attractions/attraction-view/attraction-view.component.ts